'use strict';

/** @SettingsStore */
var SettingsStore = function SettingsStore ($http, $rootScope, $q, APP_DISPATCHER_ID, Flux, IdentityService, OrganizationStore, ResourceHelper, SettingsActions, SettingsService) {
  var InvitationResource = ResourceHelper.getResource('Invitation');

  //Store init
  var SettingsStore = Flux.Store.create({
    name: 'SettingsStore',
    events: {
      Changed: true,
      CloseDetailView: true,
      InvitationError: true,
      InvitationSuccess: true,
      OpenDetailView: true,
      OpenDialog: true,
      ResendInvitation: true,
      ResetPassword: true,
      RequestHandled: true
    }
  });

  //Null initial state
  SettingsStore.$state = {
    user: '',
    plan: '',
    action: '',
    message: '',
    view: '',
    raw: ''
  };

  /**
   * Constructor function that binds to the interaction Flux.Action Signal from the component
   */
  SettingsStore.init = function init () {
    var dispatcher = Flux.Dispatcher.get(APP_DISPATCHER_ID);

    dispatcher.register(SettingsActions.AddAnotherUser, this._handleAddAnotherUser.bind(this));
    dispatcher.register(SettingsActions.CloseDetailView, this._handleCloseDetailView.bind(this));
    dispatcher.register(SettingsActions.OpenDetailView, this._handleOpenDetailView.bind(this));
    dispatcher.register(SettingsActions.OpenDialog, this._handleOpenDialog.bind(this));
    dispatcher.register(SettingsActions.ResendInvitation, this._handleResendInvitation.bind(this));
    dispatcher.register(SettingsActions.ResetPassword, this._handleResetPassword.bind(this));
    dispatcher.register(SettingsActions.RequestHandled, this._handleRequestAction.bind(this));
    dispatcher.register(SettingsActions.SendInvitation, this._handleSendInvitation.bind(this));
    dispatcher.register(SettingsActions.AddMember, this._handleAddMember.bind(this));
    dispatcher.register(SettingsActions.NotEnoughSeats, this._handleNotEnoughSeats.bind(this));
  }.bind(this);

  // Handlers //////////////////////////////////////////////////////////////////

  /**
   * Handles the visiblilty flag to show/hide the modal
   */
  this._handleAddAnotherUser = function _handleAddAnotherUser () {
    SettingsStore.$set('view', 'invitation');
    SettingsStore.emit(SettingsStore.Events.OpenDialog);
  };

  this._handleCloseDetailView = function _handleCloseDetailView () {
    SettingsStore.$set('user', {});
    SettingsStore.emit(SettingsStore.Events.CloseDetailView);
  };

  this._handleOpenDetailView = function _handleOpenDetailView () {
    SettingsStore.emit(SettingsStore.Events.OpenDetailView);
  };

  this._handleOpenDialog = function _handleOpenDialog (payload) {
    SettingsStore.$set('view', payload.view);

    if (payload.data) {
      if (payload.data.user) {
        SettingsStore.$set('user', payload.data.user);
      } if (payload.data.plan) {
        SettingsStore.$set('plan', payload.data.plan);
      } if (payload.data.message) {
        SettingsStore.$set('message', payload.data.message);
      } if (payload.data.action) {
        SettingsStore.$set('action', payload.data.action);
      } if (payload.data.upsell) {
        SettingsStore.$set('action', payload.data.upsell);
      }
    }

    SettingsStore.emit(SettingsStore.Events.OpenDialog);
  };

  this._handleResendInvitation = function _handleResendInvitation (payload) {
    SettingsStore.$set('user', payload.user);
    SettingsStore.emit(SettingsStore.Events.ResendInvitation);
  };

  this._handleResetPassword = function _handleResetPassword (payload) {
    SettingsStore.$set('user', payload.user);
    SettingsStore.emit(SettingsStore.Events.ResetPassword);
  };

  this._handleRequestAction = function _handleRequestAction (payload) {
    var data = payload.data;
    var orgId = OrganizationStore.get('current').id;
    var promise;

    InvitationResource.get(data.invitationId, {}, {
      organizationId: orgId
    }).then(function (invitation) {

      if (data.status === 'approved') {
        promise = this._handleAddMember({
          member: invitation
        });
      } else {
        promise = $q(function (resolve) {
          resolve(invitation);
        });
      }

      promise.then(function (member) {
        if (member.data && member.data.error) {
          SettingsStore.emit(SettingsStore.Events.OpenDialog);

          return;
        }

        SettingsStore.emit(SettingsStore.Events.RequestHandled);

        return InvitationResource.update(data.invitationId, {
          status: data.status,
          userId: member.id
        }, {
          organizationId: orgId
        });
      });
    }.bind(this));
  }.bind(this);

  this._handleSendInvitation = function _handleSendInvitation (payload) {
    var invitation = payload.invitation;

    return InvitationResource.create({
      invitation: invitation
    }, {
      organizationId: invitation.organizationId
    }).then(function (res) {
      // TODO: replace with an event
      SettingsStore.$set('raw', payload.invitation);
      //$rootScope.$broadcast('dialog:shareSite:promptShareSuccess', res);
      SettingsStore.emit(SettingsStore.Events.InvitationSuccess);
      return res;
    }).catch(function (err) {

      SettingsStore.$set('message', err.data.error);
      SettingsStore.$set('raw', payload.invitation);
      SettingsStore.emit(SettingsStore.Events.InvitationError);
      return err;
    });
  };

  this._handleAddMember = function _handleAddMember (payload) {
    var member = payload.member;
    if (member.name) {
      var name = member.name.split(' ');
      member.firstName = name[0];
      member.lastName = name[1];
    }

    var data = {
      firstName: member.firstName,
      lastName: member.lastName,
      email: member.email,
      organizationId: member.organizationId,
      planId: member.planId,
      projectId: member.projectId
    };

    return InvitationResource.createMember({
      data: data
    }, {
      organizationId: member.organizationId
    }).then(function (member) {
      SettingsStore.$set('raw', member);
      SettingsStore.$set('view', 'invitationSuccess');
      OrganizationStore.$set('dirty', true);
      SettingsStore.emit(SettingsStore.Events.InvitationSuccess);

      return member;
    }).catch(function (e) {
      SettingsStore.$set('message', e.data.error);
      SettingsStore.$set('raw', payload.member);
      var friendlyMessage = e.data.error.friendlyMessage;
      if (friendlyMessage === SettingsService.OUT_OF_SEATS_ERROR || friendlyMessage === SettingsService.NO_SEATS_REMAINING_ERROR) {
        SettingsStore.$set('view', 'invitationError');
        SettingsStore.emit(SettingsStore.Events.InvitationError);
      }

      return e;
    });
  };

  this._handleNotEnoughSeats = function _handleNotEnoughSeats () {
    SettingsStore.$set('view', 'invitationError');
    SettingsStore.emit(SettingsStore.Events.InvitationError);
    SettingsStore.emit(SettingsStore.Events.OpenDialog);
  };

  return SettingsStore;
};

SettingsStore.$inject = ['$http', '$rootScope', '$q', 'APP_DISPATCHER_ID', 'sbFlux', 'IdentityService', 'OrganizationStore', 'ResourceHelper', 'SettingsActions', 'SettingsService'];
module.exports = SettingsStore;



// WEBPACK FOOTER //
// ./src/app/settings/SettingsStore.js